const { Fragment } = wp.element
const { BlockControls } = wp.blockEditor
const { SVG, Path } = wp.components

const withInsertShortcodeButton = BlockEdit => {
  return props => {
    if (SUBlockEditorSettings.supportedBlocks.indexOf(props.name) === -1) {
      return <BlockEdit {...props} />
    }

    return (
      <Fragment>
        <BlockEdit {...props} />
        <BlockControls
          controls={[
            {
              icon: (
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10,3L3,3L3,21L10,21L10,17L7,17L7,7L10,7L10,3ZM14,3L21,3L21,21L14,21L14,17L17,17L17,7L14,7L14,3Z" />
                </svg>
              ),
              title: SUBlockEditorL10n.insertShortcode,
              onClick: () => {
                window.SUG.App.insert('block', { props: props })
              }
            }
          ]}
        />
      </Fragment>
    )
  }
}

wp.hooks.addFilter(
  'editor.BlockEdit',
  'shortcodes-ultimate/with-insert-shortcode-button',
  withInsertShortcodeButton
)
